(function () {
    'use strict';

    angular.module("imApp").factory("componentService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 707,
                    parameters: parms || {}
                });
            },
            getProductChanged: function (edit) {
                return $ihttp.post({
                    method: 708,
                    parameters: edit
                });
            },
            calcObj: function (mergeObj) {
                return $ihttp.post({
                    method: 2948,
                    parameters: mergeObj
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 719,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 720,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
